export const GET_USER_START =  'GET_USER_START';
export const GET_USER_SUCCESS =  'GET_USER_SUCCESS';
export const GET_USER_FAIL =  'GET_USER_FAIL';

export const UPDATE_USER_START =  'UPDATE_USER_START';
export const UPDATE_USER_SUCCESS =  'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAIL =  'UPDATE_USER_FAIL';